/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEqualizer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8 12v10H2V12zm7-10v20H9V2zm7 4v16h-6V6zM6 14H4v6h2zm7-10h-2v16h2zm7 4h-2v12h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEqualizer as Equalizer };
